export function stepsSlider() {
    const sliderNav = $('.steps-slider-nav');
    const slider = $('.steps-slider');
    const numberOfSlides = sliderNav.find('.slick-slide').length;

    slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: false,
        adaptiveHeight: true,
        asNavFor: sliderNav
    });
    sliderNav.slick({
        slidesToScroll: 1,
        slidesToShow: 2,
        arrows:false,
        infinite: false,
        asNavFor: slider,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 6
                }
            },
            {
                breakpoint: 1439,
                settings: {
                    slidesToShow: 7
                }
            },
            {
                breakpoint: 1799,
                settings: {
                    slidesToShow: 8
                }
            }
        ]
    });

    $(window).on('resize', function () {
        let slidesShown = sliderNav.slick('slickGetOption', 'slidesToShow');

        if (numberOfSlides < slidesShown) {
            setTimeout(() => {
                sliderNav.find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
            }, 100);
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/stepsSlider.js